export const DEVELOPER_ACCOUNT_MESSAGE = 'This account is marked as a developer account.'